import FlashVersion from "javascripts/flash_version";
import ConnectionAdapter from './connection_adapter';

export default class PlayerEnvironment {
  static flashVersion() {
    return (this._flashVersion = (this._flashVersion || (new FlashVersion()).get()));
  }

  static platform(){
    return (window.location.hostname.match(/^m\./) ? 'web-mobile' : 'web-desktop');
  }

  static embed(){
    return window.location.pathname.match(/^\/embed\//) ? true : false;
  }

  static referrer(){
    return document.referrer;
  }

  static currentEnv(){
    return {
      flash_version: this.flashVersion(),
      platform: this.platform(),
      embed: this.embed(),
      referrer: this.referrer(),
      app_name: 'vidio',
      lite_mode: ConnectionAdapter.liteModeEnabled()
    };
  }
}
